import type { Permission } from '@/shell/module-system'

/**
 * Capability tiers for the SPI Sample Orders board. Mirrors the backend role
 * split in `middleware/app/api/routes/sample_order.py` (`_EDIT_ROLES`).
 *
 * Unlike the Uviva Sample Requests board, there is no external vendor role
 * here — this is an SPI-internal module.
 */
export const EDIT_ROLES: Permission[] = [
  'admin',
  'sales',
  'operations', 'operations_logistics', 'purchasing',
  'outside_sales_rep',
  'inside_sales_rep',
]
